








import AbpBase from "@/lib/abpbase";
import { Component, Prop, Watch } from "vue-property-decorator";
import {
    GetTeamCityList,
    GetCityListByCommunity,
    SaveTeamCities
} from "@/api/pdTeam/index";

/**
 * 团队小区管理
 */
@Component({
    components: {}
})
export default class TeamVillage extends AbpBase {
    @Prop() currentTeam: any;
    loading: boolean = false;
    cityList: any[] = [];
    targetKeys: any[] = [];
    listStyle = {
        width: "400px",
        height: "780px"
    };

    @Watch("currentTeam", { immediate: true, deep: true })
    onTeamChanged() {
        if (this.currentTeam) {
            this.getCityListByCommunity();
        }
    }

    renderFormat = (item: any) => {
        return item.name;
    };

    handleChange(newTargetKeys: any) {
        this.targetKeys = newTargetKeys;
    }

    filterMethod(data: any, query: any) {
        return data.name.indexOf(query) > -1;
    }

    async getCityListByCommunity() {
        if (!this.currentTeam) {
            return;
        }
        let user = this.$store.state.session.user;
        if (!user || !user.communityId) {
            return;
        }

        let res = await GetCityListByCommunity(
            user.communityId,
            this.currentTeam.id
        );
        let allCityList = res.data;
        res = await GetTeamCityList(this.currentTeam.id);
        let teamCityList = res.data;

        if (allCityList) {
            //筛选出本团队管理
            let tmpList: any[] = [];
            allCityList.forEach((city: any) => {
                city.key = city.id;
                teamCityList.forEach((teamCity: any) => {
                    if (city.id == teamCity.cityId) {
                        tmpList.push(city.id);
                    }
                });
            });
            this.cityList = allCityList;
            this.targetKeys = tmpList;
        }
    }

    async submit() {
        if (!this.currentTeam) {
            return;
        }
        let payload = {
            TeamId: this.currentTeam.id,
            CityList: []
        };
        this.targetKeys.forEach(cityId => {
            payload.CityList.push(cityId);
        });
        await SaveTeamCities(payload);
    }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/setting/team/teamVillage.vue